const IsValueEmpty = value => {
  return (
    typeof value === undefined ||
    value === undefined ||
    value === null ||
    value === "" ||
    (typeof value === "string" && value.trim().length === 0)
  );
};

export const RemoveSpaces = s => {
  return !IsValueEmpty(s) ? s.replace(/\s+/g, "") : s;
};

export const lowercaseFirstLetter = str => {
  if (!str) return ""; // Handle empty strings
  return str.charAt(0).toLowerCase() + str.slice(1);
};
